/**
 * @desc Add plugin description here
 * @usage
 *   1) If using jQuery
 *      $('#dom').roompaxwidget(options)
 *
 *   2) If not using jQuery
 *      var domNode = document.getElementById('dom')
 *      var roompaxwidget = new RoomPaxWidget(domNode, options)
 *      roompaxwidget.show() // or any method of the plugin
 *
 *   3) If using HTML-based binding - simple case
 *       <a class="btn" data-roompaxwidget="click" href="http://localhost/bento/iframe.html">Click me</a>
 *
 *   4) If using HTML-based binding - with plugin attributes for example
 *       <button data-roompaxwidget="mouseover" data-animate="true" data-href="#myRoomPaxWidget" data-dismiss="false">Mouseover Me</button>
 *
 */
!function(name, module, context) {
	context = context || window
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(typeof window['define'] === 'function') define('widgets/ct_roompaxwidget',['ct_wid', 'vendor/mustache' , 'hotels/hotel_utils'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT, Mustache)
}('RoomPaxWidget', function(CT, Mustache) {
	'use strict';
	/**
	 * @desc Append the modal template markup first
	 */
	//if(tmpl) $(document.body).append(tmpl);
	/**
	 * @desc
	 *   This function checks for plugin CSS. If not present, loads automatically from 'stylesheets' folder in your web root.
	 *   If, however, your folder structure is different, you can specify the full css url, as in CT.getCSS('http://path/to/cltp_roompaxwidget.css').
	 *   Or you can add the css for the plugin with a <link> tag in the head of the document. This function need not
	 *   be commented. If the stylesheet is already loaded, it will stop further execution of the function below.
	 */
	//CSS Loader Removed!
	/**
	 * @desc default settings for the Modal component
	 */
	var defaults = {
		state: 'initialize',
		clickEvent: 'selectRoom',
		//click event used to add the room
		changeEventAdult: 'alterAdult',
		//change event used to alter the adults
		changeEventChild: 'alterChild' // change event used to alter the childs
		//default state of roompaxwidget unless specified by user
		// Add more default options here
	};

	/* ------------------------------------- Private methods below --------------------------------------- */
	/**
	 * @desc Desc of the private method
	 * @return Add return
	 */

	function myprivate() {

	}

	function bindChange(data) {


		$(data.el).on("change", "." + data.settings.clickEvent, function(event) {
		    	
			var roomCount = $(data.el).find('li').length;
			var currentRoomSel = Number($(event.target).val());
			var isSevenPlus = false;
			$(data.el).parent().find("#NoOfRoom").val(currentRoomSel);
			if(currentRoomSel === 7){
				currentRoomSel = 1;
				isSevenPlus = true;
			}
			if($(".roomWidget .rooms .row").find(".col:nth-child(2)").css('display') == 'none'){
				$(".roomWidget .rooms .row").find(".col:not(div:nth-child(1))").css('display','block');
			}
			if(currentRoomSel > roomCount) {
				addRooms(currentRoomSel, roomCount);
				$(data.el).parent().find("#Room1").show();
			} else {
				if(currentRoomSel === 1 && $(data.el).closest("form").attr("id") != "HotelSearch") {
					$(data.el).parent().find("#Room1").hide();
				}
				removeRooms(currentRoomSel, roomCount);
				if(isSevenPlus){
					$(".roomWidget .rooms .row").find(".col:not(div:nth-child(1))").css('display','none');
				}

			}
			CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS','H_Search_Rooms','Rooms'+currentRoomSel,'100');

		});

		function addRooms(currentRoomSel, roomCount) {
			var noOfRoom = currentRoomSel - roomCount;
			var dataObj = {
				roomWid: [

				]
			};
			for(var i = 0; i < noOfRoom; i++) {
				dataObj.roomWid.push({
					roomId: roomCount + 1
				})
				roomCount++;
			}
			var html = CT.to_html(data.settings.template, dataObj);
			$(data.el).find('ul').append(html);
		}

		function removeRooms(currentRoomSel, roomCount) {
			//	var noOfRoom=currentRoomSel-roomCount;
			for(var i = roomCount - 1; i >= currentRoomSel; i--) {
				$($(data.el).find('li')[i]).remove();
			}

		}

		return this;
	}



	function bindChangeAdult(data) {

		$(data.el).on("change", "." + data.settings.changeEventAdult, function(event) {

			var totalPaxDefault = 12;
			var maxChildPerRoom = 6;
			var totalPax;
			var index = this.id.split('_')[1];
			var noOfAdult = Number(this.value);
			var ChildRef = $(data.el).find('select#Childs_' + index);
			var ChildRefValue = ChildRef.val();
			var noOfChild = ChildRef.children().length - 1;
			totalPax = noOfAdult + noOfChild;
			if(noOfAdult > 1 && totalPax > totalPaxDefault) {
				var childEleRemoveCount = totalPax - totalPaxDefault;
				for(var j = 0; j < childEleRemoveCount; j++) {
					ChildRef.find('option[value="' + String(noOfChild) + '"]').remove();
					var childAgeRef = $(this).parents('li.rooms').find('#AgeOfChild' + noOfChild);
					//$(data.el).find('#ageChild'+noOfChild);
					$(childAgeRef).remove();

					noOfChild--;
				}
				if(ChildRefValue > noOfChild) {
					ChildRef.val(String(ChildRef.find('option').length - 1));
				}
			} else {
				var childEleAddCount = totalPaxDefault - totalPax;
				if((childEleAddCount + noOfChild) > maxChildPerRoom){
					childEleAddCount = maxChildPerRoom - noOfChild;
				}
				for(var i = 0; i < childEleAddCount; i++) {
					ChildRef.append('<option value="' + String(noOfChild + 1) + '">' + (noOfChild + 1) + '</option>')
					noOfChild++;
				}
			}
			CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS','H_Search_Adults','Room'+index+'Adults'+noOfAdult,'100');
			if(window.location.pathname.indexOf("/details")!=-1){
				var noOfRoom = Number($(event.target).parents().find("#NoOfRoom").val());
				var numAdults = 0;
				var numChilds=0;
				for(var i = 1; i <= noOfRoom; i++) {
				numAdults += Number($(event.target).parents().find("#Adult_" + i).val());
				numChilds += Number($(event.target).parents().find("#Childs_" + i).val());
				}
				if(numAdults)
                CT.utils.helperFunctions.trackMixpanelEvent('Travellerschanged_Inwidget',{'numAdults':numAdults,'numChildren':numChilds});
			}
		});
		return this;
	}

	function bindChangeChild(data) {
		var that = data;
		$(that.el).on("change", "." + that.settings.changeEventChild, function(event) {
			var childCount = Number(this.value);
			var index = this.id.split('_')[1];
			var childAgeRef = $(that.el).parent().find("#Age_" + index).find(".row").find('select');
			var childAgeLength = childAgeRef.length;
			var j = childAgeLength + 1;

			if(childCount < childAgeLength) {
				var diff = childAgeLength - childCount;
				for(var i = 0; i < diff; i++) {
					var childAgeRefRemove = $(this).parents('li.rooms').find('#AgeOfChild' + childAgeLength);
					$(childAgeRefRemove).parent().find("small.ugly").remove();
					$(childAgeRefRemove).remove();
					childAgeLength--;
					//childAgeRef[childAgeLength-1].remove();
				}
			} else {
				var diff = childCount - childAgeLength;
				var dataObj = {
					ref: index,
					childAge: [

					]
				};

				for(var i = 0; i < diff; i++) {

					dataObj.childAge.push({
						roomId: j
					});
					j++;

				}
				var html = CT.to_html('ChildAgeTpl', dataObj);
				$(that.el).parent().find("#Age_" + index).find(".row").append(html)
				$(that.el).parent().find("#Age_" + index).show();
				// $($(that.el).parents().find("#age_"+index)).append(html);
				// $($(that.el).parents().find("#age_"+index)).show();
			}
			//console.log("Child changed = "+childCount)
			//CT.utils.helperFunctions.trackGAEvent('Hotels_TS','H_Search_Child','Child'+childCount,'3000');
			if(window.location.pathname.indexOf("/details")!=-1 || window.location.pathname.indexOf("/hotels")!=-1){
				var noOfRoom = Number($(event.target).parents().find("#NoOfRoom").val());
				var numAdults = 0;
				var numChilds=0;
				for(var i = 1; i <= noOfRoom; i++) {
				numAdults += Number($(event.target).parents().find("#Adult_" + i).val());
				numChilds += Number($(event.target).parents().find("#Childs_" + i).val());
				}
				if(numAdults)
                CT.utils.helperFunctions.trackMixpanelEvent('Travellerschanged_Inwidget',{'numAdults':numAdults,'numChildren':numChilds});
			}
		});

		return this;
	}

	function bindModifyEvents(data) {
		var parent = $(data.el).parent();
		parent.find(".travellersAdded").bind('click', function(event) {
			var noOfRoom = Number($(event.target).parent().find("#NoOfRoom").val());
			var totalGuest = 0;
			for(var i = 1; i <= noOfRoom; i++) {
				totalGuest += Number($(event.target).parent().find("#Adult_" + i).val()) + Number($(event.target).parent().find("#Childs_" + i).val());
			}

			var finalString = totalGuest + ((totalGuest ==1) ? " guest" : " guests") +", " + noOfRoom +((noOfRoom ==1) ? " room" : " rooms");
			parent.parent().find('.noOfTraveller').val(finalString);
			parent.hide();
		})

		parent.parent().find('.noOfTraveller').bind('focus', function() {
			//parent.find(".roomNo").removeClass("vertical").addClass("horizontal");
			parent.find("#Room1").show();
			parent.show();
		});
		parent.find(".modifyChangeRooms").bind("click",function(event){
			$(".travellersAdded").trigger('click');
		})
		$(document).bind('click', function(e) {
			if($(e.target).hasClass('addTraveller') || $(e.target).hasClass('noOfTraveller')) {

			} else if($(e.target).parents().closest('.addTraveller').length > 0) {
				if($(e.target).hasClass("travellersAdded")) {
					$("#addTravellerPopover").hide();
				}
			} else {
				$("#addTravellerPopover").hide();
				$(".travellersAdded").trigger('click');
			}


		});
		parent.find(".closeTravellerPopOver").bind("click",function(event){
			$("#addTravellerPopover").hide();
		})

	}

	/* ------------------------------------- Private methods section ends --------------------------------------- */



	/* ------------------------------------- COMPONENT DEFINITION -------------------------------------------- */

	function RoomPaxWidget(el, options) {
		this.el = el;
		this.settings = options;
	}

	RoomPaxWidget.prototype = {
		constructor: RoomPaxWidget,

		// Add prototype methods
		/**
		 * @desc 'alert' state of the plugin
		 */
		initialize: function() {
			var data = this.settings;

			if(typeof data.clickEvent !== "undefined") {
				bindChange(this);
			}
			if(typeof data.changeEventAdult !== "undefined") {
				bindChangeAdult.call(true, this);
			}
			if(typeof data.changeEventChild !== "undefined") {
				bindChangeChild(this);
			}
			if(typeof data.modify !== "undefined") {
				bindModifyEvents(this);
			}

		}

	}

	function execRoomPaxWidget(e, data) {
		e && e.preventDefault();
		data = data || $(this).data('ct_room_pax_widget');
		new RoomPaxWidget(this, data)[data.state]();
	} /* -------------------------------------------------------------------------------------------------------------- */


	// Manual binding - when user calls the plugin via javascript
	$.fn[$.fn.roompaxwidget ? 'ctroompaxwidget' : 'roompaxwidget'] = function(options) {
		return this.each(function() {
			var $elem = $(this) //caching
			,
				htmlSettings = $elem.data('ct_room_pax_widget'),
				settings = {};

			if(!htmlSettings) $elem.data('ct_room_pax_widget', (htmlSettings = CT.getHTMLSettings(this))); // check and store plugin settings from HTML attrs
			if(typeof options === 'string') settings.state = options; // If user sends a string (instead of hash) defining state of the plugin
			$.extend(settings, defaults, htmlSettings, typeof options === 'object' && options);
			execRoomPaxWidget.call(this, undefined, settings);
		});
	};

	// Auto binding
	$('[data-roompaxwidget]').each(function() {
		var $elem = $(this),
			evt = $elem.attr('data-roompaxwidget') || 'click';
		$elem.data('ct_room_pax_widget', $.extend({}, defaults, CT.getHTMLSettings(this))).bind(evt, execRoomPaxWidget);
		execRoomPaxWidget.call(this);
	});

	return RoomPaxWidget;
}, this)
;
